module.exports = __webpack_public_path__ + "static/media/0028_IMG_LES_ENSEIGNES_LE_COMPTOIR_DES_SAVEURS.8633c9df.webp";